module.exports = __webpack_public_path__ + "static/media/Pic-0094.12c3dd5d.jpg";